export default __webpack_public_path__ + "static/media/icon-1.873ffb18.svg";